import validate from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}